import { createFeature, useTranslation } from '@edreamsodigeo/frontend-core';
import { Body, Box } from '@edreamsodigeo/prisma-design-system';
import {
  CONFIRMATION,
  OFFERS,
  PAX,
  PAYMENT,
} from '@/hooks/usePriceFreezeRouter';
import React from 'react';
import { PRIME_FIRST_PHASE_2_DESKTOP } from '@/versionedComponents';
import { useIsPrimeUser } from '@/hooks/useIsPrimeUser';

const BreadcrumbPrimeFirst = (props) => (
  <Breadcrumb {...props} isPrimeFirstEnabled />
);

export const Breadcrumb = ({ page, isPrimeFirstEnabled }) => {
  const { t } = useTranslation();
  const isPrimeUser = useIsPrimeUser();
  const stepSeparator = ' > ';

  return (
    <Body color="neutral.0" type="small">
      <Body as="span" weight="medium" inline>
        {t('header.breadcrumb.title')}:
      </Body>
      <Box as="span" ml="small">
        <Body as="span" inline>
          {t('header.breadcrumb.desc1')}
        </Body>
        {stepSeparator}
        <Body as="span" inline>
          {t('header.breadcrumb.desc2')}
        </Body>
        {stepSeparator}
        {isPrimeFirstEnabled && !isPrimeUser ? (
          <Body as="span" inline weight={page === OFFERS ? 'medium' : ''}>
            {t('header.breadcrumb.pfOptions')}
          </Body>
        ) : (
          <Body as="span" inline weight={page === PAX ? 'medium' : ''}>
            {t('header.breadcrumb.desc3')}
          </Body>
        )}
        {stepSeparator}
        <Body as="span" inline weight={page === PAYMENT ? 'medium' : ''}>
          {t('header.breadcrumb.desc4')}
        </Body>
        {stepSeparator}
        <Body as="span" inline weight={page === CONFIRMATION ? 'medium' : ''}>
          {t('header.breadcrumb.desc5')}
        </Body>
      </Box>
    </Body>
  );
};

export const BreadcrumbPrimeFirstVersioned = createFeature({
  name: PRIME_FIRST_PHASE_2_DESKTOP,
  variations: [Breadcrumb, BreadcrumbPrimeFirst, BreadcrumbPrimeFirst],
  version: 1,
});
